import { createStructuredSelector } from 'reselect'

import {
  ASSESSMENT_DOCUMENT_TYPE_LIST,
  ASSESSMENT_DOCUMENT_TYPE_LIST_SUCCESS, 
  ASSESSMENT_DOCUMENT_TYPE_LIST_ERROR,
  ASSESSMENT_DOCUMENT_TYPE_PAGE_SET,
  ASSESSMENT_DOCUMENT_TYPE_SEARCH_SET,
  ASSESSMENT_DOCUMENT_TYPE_SEARCH_CHANGE,
  ASSESSMENT_DOCUMENT_TYPE_ADD_SET,
  ASSESSMENT_DOCUMENT_TYPE_ADD_MODAL_SET,
  ASSESSMENT_DOCUMENT_TYPE_ADD,
  ASSESSMENT_DOCUMENT_TYPE_ADD_SUCCESS,
  ASSESSMENT_DOCUMENT_TYPE_ADD_ERROR,
  ASSESSMENT_DOCUMENT_TYPE_ADD_CHANGE,
  ASSESSMENT_DOCUMENT_TYPE_DETAIL,
  ASSESSMENT_DOCUMENT_TYPE_DETAIL_SUCCESS,
  ASSESSMENT_DOCUMENT_TYPE_DETAIL_ERROR,
  ASSESSMENT_DOCUMENT_TYPE_VIEW_MODAL_SET,
  ASSESSMENT_DOCUMENT_TYPE_EDIT_CHANGE,
  ASSESSMENT_DOCUMENT_TYPE_EDIT_MODAL_SET,
  ASSESSMENT_DOCUMENT_TYPE_UPDATE,
  ASSESSMENT_DOCUMENT_TYPE_UPDATE_SUCCESS,
  ASSESSMENT_DOCUMENT_TYPE_UPDATE_ERROR,
  ASSESSMENT_DOCUMENT_TYPE_VIEW_TAB_SET
} from '../../actions';

export const NAME = 'assessment_document_type';

export const AssessmentDocumentTypeList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type: ASSESSMENT_DOCUMENT_TYPE_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const AssessmentDocumentTypeListSuccess = (data) => ({
  type: ASSESSMENT_DOCUMENT_TYPE_LIST_SUCCESS,
  payload: data
});

export const AssessmentDocumentTypeListError = (error) => ({
  type: ASSESSMENT_DOCUMENT_TYPE_LIST_ERROR,
  payload: error
});

export const AssessmentDocumentTypePageSet = (data) => ({
  type: ASSESSMENT_DOCUMENT_TYPE_PAGE_SET,
  payload: data
});

export const AssessmentDocumentTypeSearchSet = (data) => ({
  type: ASSESSMENT_DOCUMENT_TYPE_SEARCH_SET,
  payload: data
});

export const AssessmentDocumentTypeSearchChangeSet = (data) => ({
  type: ASSESSMENT_DOCUMENT_TYPE_SEARCH_CHANGE,
  payload: data
});

export const AssessmentDocumentTypeAddChangeSet = (data) => ({
  type: ASSESSMENT_DOCUMENT_TYPE_ADD_CHANGE,
  payload: data
});

export const AssessmentDocumentTypeAddSet = (data) => ({
  type: ASSESSMENT_DOCUMENT_TYPE_ADD_SET,
  payload: data
});

export const AssessmentDocumentTypeAddModalSet = (data) => ({
  type: ASSESSMENT_DOCUMENT_TYPE_ADD_MODAL_SET,
  payload: data
});

export const AssessmentDocumentTypeAdd = (data) => ({
  type: ASSESSMENT_DOCUMENT_TYPE_ADD,
  payload: data
});

export const AssessmentDocumentTypeAddSuccess = (message) => ({
  type: ASSESSMENT_DOCUMENT_TYPE_ADD_SUCCESS,
  payload: message
});

export const AssessmentDocumentTypeAddError = (error) => ({
  type: ASSESSMENT_DOCUMENT_TYPE_ADD_ERROR,
  payload: error
});

export const AssessmentDocumentTypeDetail = (data) => ({
  type: ASSESSMENT_DOCUMENT_TYPE_DETAIL,
  payload: data
});

export const AssessmentDocumentTypeDetailSuccess = (data) => ({
  type: ASSESSMENT_DOCUMENT_TYPE_DETAIL_SUCCESS,
  payload: data
});

export const AssessmentDocumentTypeDetailError = (error) => ({
  type: ASSESSMENT_DOCUMENT_TYPE_DETAIL_ERROR,
  payload: error
});

export const AssessmentDocumentTypeViewModalSet = (data) => ({
  type: ASSESSMENT_DOCUMENT_TYPE_VIEW_MODAL_SET,
  payload: data
});

export const AssessmentDocumentTypeEditModalSet = (data) => ({
  type: ASSESSMENT_DOCUMENT_TYPE_EDIT_MODAL_SET,
  payload: data
});

export const AssessmentDocumentTypeEditChangeSet = (data) => ({
  type: ASSESSMENT_DOCUMENT_TYPE_EDIT_CHANGE,
  payload: data
});

export const AssessmentDocumentTypeUpdate = (data) => ({
  type: ASSESSMENT_DOCUMENT_TYPE_UPDATE,
  payload: data
});

export const AssessmentDocumentTypeUpdateSuccess = (message) => ({
  type: ASSESSMENT_DOCUMENT_TYPE_UPDATE_SUCCESS,
  payload: message.message
});

export const AssessmentDocumentTypeUpdateError = (error) => ({
  type: ASSESSMENT_DOCUMENT_TYPE_UPDATE_ERROR,
  payload: error
});

export const AssessmentDocumentTypeViewTabSet = (data) => ({
  type: ASSESSMENT_DOCUMENT_TYPE_VIEW_TAB_SET,
  payload: data
});

const assessment_document_type = (state) => state[NAME];

export const AssessmentDocumentTypeSelector = createStructuredSelector({
  assessment_document_type
})
 